/*
 * @Autor: liuzilei3
 * @Email: liuzilei3@jd.com
 * @Description:
 * @CreateDate: Do not edit
 * @LastEditors: liuzilei3
 */
import {
  Text,
  computed,
  inject,
  ref,
  useSlots,
  onMounted,
  nextTick,
} from 'vue'
import {
  useFormDisabled,
  useFormItem,
  useFormSize,
} from '@jdesign-vue/components/form'
// import { useNamespace } from '@jdesign-vue/hooks'
import { useGlobalConfig } from '@jdesign-vue/components/config-provider'
// import { useDeprecated } from '@jdesign-vue/hooks'
import { useNamespace } from '@jdesign-vue/hooks'
import { buttonGroupContextKey } from './constants'

import type { SetupContext } from 'vue'
import type { ButtonEmits, ButtonProps } from './button'

export const useButton = (
  props: ButtonProps,
  emit: SetupContext<ButtonEmits>['emit']
) => {
  // 关闭废弃警告，待进一步确认
  // useDeprecated(
  //   {
  //     from: 'type.text',
  //     replacement: 'link',
  //     version: '3.0.0',
  //     scope: 'props',
  //     ref: 'https://jdesign-vue.org/en-US/component/button.html#button-attributes',
  //   },
  //   computed(() => props.type === 'text')
  // )

  const buttonGroupContext = inject(buttonGroupContextKey, undefined)
  const globalConfig = useGlobalConfig('button')
  const { form } = useFormItem()
  // @ts-ignore
  const _size = useFormSize(computed(() => buttonGroupContext?.size))
  const _disabled = useFormDisabled()
  const _ref = ref<HTMLButtonElement>()
  const slots = useSlots()
  const ns = useNamespace('button')

  const _type = computed(() => props.type || buttonGroupContext?.type || '')
  const autoInsertSpace = computed(
    () => props.autoInsertSpace ?? globalConfig.value?.autoInsertSpace ?? false
  )

  const _props = computed(() => {
    if (props.tag === 'button') {
      return {
        ariaDisabled: _disabled.value || props.loading,
        disabled: _disabled.value || props.loading,
        autofocus: props.autofocus,
        type: props.nativeType,
      }
    }
    return {}
  })

  // add space between two characters in Chinese
  const shouldAddSpace = computed(() => {
    const defaultSlot = slots.default?.()
    if (autoInsertSpace.value && defaultSlot?.length === 1) {
      const slot = defaultSlot[0]
      if (slot?.type === Text) {
        const text = slot.children as string
        return /^\p{Unified_Ideograph}{2}$/u.test(text.trim())
      }
    }
    return false
  })

  const handleClick = (evt: MouseEvent) => {
    if (props.nativeType === 'reset') {
      form?.resetFields()
    }
    emit('click', evt)
  }
  const wrapTextWrapper = ref<HTMLElement | null>(null)
  const isWrap = ref(false)

  // 计算是否需要文本换行
  function calculateWrap() {
    nextTick(() => {
      // 前置条件守卫：缺少关键 DOM 或配置时直接退出
      if (!props.wrap || !_ref.value || !wrapTextWrapper.value) return
      // 获取关键节点与样式
      const buttonEl = _ref.value
      const textEl = wrapTextWrapper.value
      // 计算图标宽度
      let iconWidth = 0
      const iconElement = buttonEl.querySelector(
        `${ns.namespace.value}-icon, .${ns.namespace.value}-icon`
      ) as HTMLElement
      if (iconElement) {
        iconWidth = iconElement.offsetWidth
      }
      // 计算可用宽度（按钮总宽度 - 图标宽度 - 内边距）
      const availableWidth = buttonEl.offsetWidth - iconWidth - 32
      const textWidth = textEl.offsetWidth
      const needsWrap = Math.ceil(textWidth / availableWidth) > 1
      isWrap.value = needsWrap
    })
  }

  onMounted(() => {
    props.wrap && calculateWrap()
  })
  return {
    _disabled,
    _size,
    _type,
    _ref,
    _props,
    shouldAddSpace,
    handleClick,
    wrapTextWrapper,
    isWrap,
  }
}
